import axios from 'axios'
import { ElMessage } from 'element-plus'

// 创建 axios 实例
const service = axios.create({
  baseURL: '/app-api', // TODO: 替换为你的后端API地址
  timeout: 30000  // 增加到30秒
})

function clearAuthAndRedirect() {
  // 清除本地存储的token
  localStorage.removeItem('token')
  localStorage.removeItem('userInfo')
  // 跳转到登录页，并记录当前页面地址以便登录后返回（避免引入 router 造成循环依赖）
  const redirect = window.location.pathname + window.location.search + window.location.hash
  const loginUrl = `/login?redirect=${encodeURIComponent(redirect)}`
  // 使用 replace 避免保留无效历史栈
  window.location.replace(loginUrl)
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 自动携带 token
    const token = localStorage.getItem('token')
    if (token && config.headers.isToken !== false) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 兼容后端使用 200 + 业务码 401 的情况
    const data = response.data
    const bizCode = data?.code
    if (response.status === 401 || bizCode === 401) {
      ElMessage.error('登录已过期，请重新登录')
      clearAuthAndRedirect()
      return Promise.reject(data)
    }
    // 正常返回后端数据
    return data
  },
  error => {
    // 统一错误提示
    // 处理401未授权错误（通常表示token失效）
    console.log(error+'errorAAAAAAAAAAAAAAAAAAAAAAAAAAA')
    console.log(error.response+'error.responseAAAAAAAAAAAAAAAAAAAAAAAAAAA')
    const httpStatus = error?.response?.status
    const respCode = error?.response?.data?.code
    if (httpStatus === 401 || respCode === 401) {
      ElMessage.error('登录已过期，请重新登录')
      clearAuthAndRedirect()
      
      // 可以添加提示信息
      
    }else if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
      console.error('请求超时:', error)
      alert('请求超时，请检查网络连接或稍后重试')
    } else if (error.response) {
      console.error('请求错误:', error.response.data)
      alert(error.response.data.msg || '请求出错')
    } else {
      console.error('网络错误:', error)
      alert('网络错误，请检查网络连接')
    }
    return Promise.reject(error)
  }
)
  
export default service